import AppHeader, { AppWrapper } from '../../components/AppView';
import AppBody from '../AppBody';
import {
  TOKEN_ADDRESS,SIMPLESAWP_ADDRESS, USDT_ADDRESS,LOCKED_ADDRESS
} from '../../constants/address';
import { useCallback, useEffect, useMemo, useState } from 'react';
import NumericalInput from '../../components/NumericalInput';
import AddressInput from '../../components/AddressInput';

import Row from '../../components/Row';
import {
   ButtonPrimary,ButtonLight,
} from '../../components/Button';

import { AutoColumn } from '../../components/Column';
import styled, { useTheme } from 'styled-components';

import { Trans } from '@lingui/macro';

import useLocked from '../../hooks/useLocked';

import Loader from '../../components/Loader';
import { fromAmount, toAmount } from '../../utils/amount';

import { useWallet } from 'use-wallet';
import useERC20Allowance from '../../hooks/useERC20Allowance';
import useERC20Approve from '../../hooks/useERC20Approve';
import useERC20Balance from '../../hooks/useERC20Balance';
import useToken from '../../hooks/useToken';
import Big from 'big.js';
import { ZERO_ADDRESS } from '../../utils/ethereum';
import Modal from '../../components/Modal';
import { LoadingView, SubmittedView } from '../../components/ModalViews';
import PromoteBanner from '../../components/PromoteBanner';



const LabelWrapper = styled.div`
  font-size: 14px;
`;
const InputAddress = styled(AddressInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;

const InputText = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  padding: 4px 2px;
  font-size: 14px;
`;

const ItemActionWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  & > * {
    flex: 1;
    margin-right: 8px;
  }

  & > *:last-child {
    margin-right: unset;
  }
`;

function LockedConsole() {
  const {
    chainId,
    account,
    // balance,
  } = useWallet();
  // const theme = useTheme();
  const {
    LockedContract,
    lockedBalance,
    withdraw,
    lockedTokens,
    deposit,
    balanceOf,
    getPledgeList,
    getToken,
    adminWithdraw,
  } = useLocked(LOCKED_ADDRESS[chainId]);

  const [token] = useToken(TOKEN_ADDRESS[chainId]);
  const tokenContract = useMemo(() => {
    if (token) {
      return token.contract;
    }
    return null;
  }, [token]);


  const tokenBalance = useERC20Balance(tokenContract, account);
  const [allowance, fetchAllowance] = useERC20Allowance(
    tokenContract, account, LOCKED_ADDRESS[chainId]);

  const [onApprove, approveLoading] = useERC20Approve(
    tokenContract, LOCKED_ADDRESS[chainId]);

  //const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState('');
  const [lockAddress, setLockAddress] = useState('');
  const [outputValueEnough, setOutputValueEnough] = useState(true);

  const [loading, setLoading] = useState(false);
  const [isSubmitShow, setIsSubmitShow] = useState(false);
  const [submitHash, setSubmitHash] = useState('');
  const [submitError, setSubmitError] = useState('');

  const [startprenum, setStartprenum] = useState(0);
  const [pledgedays, setPledgedays] = useState(0);
  const [gapdays, setGapdays] = useState(0);
  
  


  const [withdrawloading, setWithdrawLoading] = useState(false); // 存款
  const [depositloading, setdepositloading] = useState(false); // 提现

  useEffect(() => {
    const fetch = async () => {
      const token2 =await getToken();
      console.log('locked token:',token2);
      console.log('LockedContract address:',LockedContract);
    };
    if (getToken && LockedContract) {
      fetch();
    }
  },[getToken,LockedContract]);
  // 管理员提现
  const handleWithdraw = useCallback(async () => {
    const tx = await lockedTokens(lockAddress, fromAmount(value, token?token.decimals:18),setWithdrawLoading);
    setSubmitHash(tx.hash);
    setValue('');
  }, [
    token,
    value,
    lockAddress,
    lockedTokens
  ]);

  const handleOnApprove = useCallback(async () => {
    await onApprove(fromAmount(value, token?token.decimals:18));
    await fetchAllowance();
  }, [
    token,
    fetchAllowance,
    onApprove,
    value,
  ]);

    // 管理员存款
  const handledeposit = useCallback(async () => {
      const tx = await deposit( fromAmount(value, token?token.decimals:18),setdepositloading);
      setSubmitHash(tx.hash);
      setValue('');
    }, [
      value,
      token,
      deposit
    ]);

  const handlelockedTokens = useCallback(async () => {
    setIsSubmitShow(true);
    setSubmitHash('');
    setSubmitError('');
  console.log('handlelockedTokens value', fromAmount(value, token?token.decimals:18));
    try {
      const tx = await lockedTokens(lockAddress, fromAmount(value, token?token.decimals:18), pledgedays,gapdays,startprenum,setLoading,true);
      setSubmitHash(tx.hash);
      setValue('');
    } catch (e) {
      console.log(e);
      setSubmitError(e.message);
    }
  }, [
    token,
    pledgedays,
    gapdays,
    startprenum,
    value,
    lockAddress,
    lockedTokens
  ]);

  return (
    <>
    
      <AppBody>
        <AppHeader>
          <Trans>Set Locked Tokens</Trans>
        </AppHeader>
        <AppWrapper>
          <AutoColumn gap={ 'sm' }>
            <AutoColumn gap={ '2px' }>
            <AutoColumn gap={ 'sm' }>
            <LabelWrapper>
              <Trans>Lock Address</Trans>
            </LabelWrapper>
            <Row>
                <InputAddress value={ lockAddress }
                           onUserInput={ setLockAddress } />
                
              </Row>
          </AutoColumn>
            <AutoColumn gap={ 'sm' }>
            <LabelWrapper>
              <Trans>Lock Amount</Trans>
            </LabelWrapper>
            <Row>
                <InputText value={ value }
                           onUserInput={ setValue } />
                <Symbol>{'PRT' }</Symbol>
              </Row>
          </AutoColumn>

          <AutoColumn gap={ 'sm' }>
            <LabelWrapper>
              <Trans>Locked Days</Trans>
            </LabelWrapper>
            <Row>
                <InputAddress value={ pledgedays }
                           onUserInput={ setPledgedays } />
                
              </Row>
          </AutoColumn>

                   <AutoColumn gap={ 'sm' }>
            <LabelWrapper>
              <Trans>Release Interval Days</Trans>
            </LabelWrapper>
            <Row>
                <InputAddress value={ gapdays }
                           onUserInput={ setGapdays } />
                
              </Row>
          </AutoColumn>

                    <AutoColumn gap={ 'sm' }>
            <LabelWrapper>
              <Trans>initial release Ratio(%)</Trans>
            </LabelWrapper>
            <Row>
                <InputAddress value={ startprenum }
                           onUserInput={ setStartprenum } />
                
              </Row>
          </AutoColumn>


              <BalanceWrapper>
                <Trans>All amount: { (lockedBalance && lockedBalance.allamount) || '0' }</Trans> { 'PRT' }
              </BalanceWrapper>
              <BalanceWrapper>
               <Trans>allowance: {toAmount(allowance || '0', token?token.decimals:18)}</Trans> { 'PRT' } 
              </BalanceWrapper>
            </AutoColumn>
            <ItemActionWrapper>
              
            { allowance.lt(fromAmount(value || '0', token?token.decimals:18)) ? (
              <ButtonPrimary
                disabled={ approveLoading }
                onClick={ handleOnApprove }
              >
              { approveLoading ? <Loader /> : <Trans>Approve</Trans> }
              </ButtonPrimary>
            ) : (
              <ButtonPrimary
                onClick={ handlelockedTokens }
                disabled={ loading || (!value) || value <= 0  }>
                { !outputValueEnough ? <Trans>Not enough balance</Trans> :
                  <Trans>Locked </Trans> }
                { loading ? <Loader /> : null }
              </ButtonPrimary>)}


              <ButtonLight
                disabled={ (!value) || value <= 0 || withdrawloading } onClick={ handleWithdraw }>
              
                  <Trans>Withdraw </Trans> 
                { withdrawloading ? <Loader /> : null }
              </ButtonLight>

              <ButtonLight
                disabled={ (!value) || value <= 0 || approveLoading || (allowance.lt(fromAmount(value || '0', token?token.decimals:18))) }
                onClick={ handledeposit }>
                  <Trans>Deposit </Trans> 
                { depositloading ? <Loader /> : null }
              </ButtonLight>
              </ItemActionWrapper>
          </AutoColumn>
        </AppWrapper>

        <Modal isOpen={ isSubmitShow }
               onDismiss={ () => setIsSubmitShow(false) }>
          { loading ? (
            <LoadingView onDismiss={ () => setIsSubmitShow(false) } />
          ) : (
            <SubmittedView onDismiss={ () => setIsSubmitShow(false) }
                           hash={ submitHash }>
              { submitError ? (
                submitError
              ) : <Trans>Locked Succeeded.</Trans> }
            </SubmittedView>
          ) }
        </Modal>
      </AppBody>
    </>
  );
}

export default LockedConsole;
